const getOrchidProTypeOrder = (typeIndex) => {
  switch (typeIndex) {
    case 0:
      return "Primary Professional";
    case 1:
      return "Secondary Professional";
    case 2:
      return "Third Professional";
    default:
      return "Primary Professional";
  }
};

export default getOrchidProTypeOrder;
